import { GET } from "../APiHelper/API"

export const getFormationPositions = (onSuccess, onError) => {

    GET(`/api/v1/squads/formation_positions`, onSuccess, onError)
}
